import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {
  StyledSelect,
  StyledTextField,
  StyledFormControl,
} from "../components/StyledComponents/Inputs/Inputs.js";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PlaceHolderButton from "../components/PlaceHolderButton/PlaceHolderButton.js";
import * as EmailValidator from "email-validator";
import * as api from "../api/api";
import CloseIcon from "@mui/icons-material/Close";
import {
  StyledIconButton,
  StyledLabel,
} from "../components/StyledComponents/Buttons/AuradineButtons";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import {
  Box,
  capitalize,
  FormControl,
  Select,
  Stack,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import Styled from "@emotion/styled";
import {
  StyledDialog,
  StyledDialogTitle,
} from "../components/StyledComponents/Dialog/Dialog";
import { useTheme } from "../ThemeContext/ThemeContext.js";
import {
  PrimaryButton,
  SecondaryButton,
} from "../components/StyledComponents/Buttons/AuradineButtons";
import {
  BodyLarge,
  BodySmall,
  BodyMedium,
  H6HeadlineSmall,
} from "../components/StyledComponents/Typography/Typography.tsx";
import {
  StyledMenu,
  StyledMenuItem,
} from "../components/StyledComponents/Menu/Menu.tsx";
import { StyledInputLabel } from "../components/StyledComponents/Inputs/Inputs.js";
import useAppContextProvider from "../AppContext/useAppContextProvider.js";
import { useGetSiteLists } from "../api/queries/useGetSiteLists.ts";

const SuccessModal = ({ isOpen, onClose, Status, Msg }) => {
  console.log("status is", Status);
  let h4Msg = "";
  let pMsg = "";
  switch (Status) {
    case "ok":
      h4Msg = "Success!";
      pMsg = Msg;
      break;
    case "error":
      h4Msg = "Failed!";
      pMsg = Msg;
      break;
    case "unauth":
      h4Msg = "Authorization Failed!";
      pMsg = Msg;
      break;
    default:
      h4Msg = "Unknown Error";
      pMsg =
        "Unable to fetch the data. Try refreshing the page. If issue still persists, please contact Technical Support at Aurascape";
      break;
  }
  return (
    <Popup
      className="popup1-content"
      open={isOpen}
      onClose={onClose}
    >
      <h4 className="popup-title">{h4Msg}</h4>
      <p className="success-message">{pMsg}</p>
      <div className="button-container">
        <button onClick={onClose}>Close</button>
      </div>
    </Popup>
  );
};

export default function InviteDialog({
  setState,
  org,
  userRole,
  refetch: membersDataRefetch,
}) {
  const { isAuthenticated, getAccessTokenSilently } =
    useAuth0();
  const [authToken, setAuthToken] = React.useState("");
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const { colors } = useTheme();

  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [name, setName] = React.useState("");
  const [role, setRole] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [siteOptions, setSiteOptions] = React.useState([]);
  const [error, setError] = React.useState({
    error: false,
    helperText: "",
  });
  const [errorRole, setErrorRole] = React.useState({
    error: false,
    helperText: "",
  });

  const [errorName, setErrorName] = React.useState({
    error: false,
    helperText: "",
  });

  const roleHierarchy = {
    superadmin: 4,
    pooladmin: 3,
    admin: 2,
    user: 1,
  };

  React.useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  const {
    data: siteLists,
    isLoading: isSiteGroupDataLoading,
    isFetching: isSiteGroupDataFetching,
    isFetched: isSiteGroupDataFetched,
    refetch: siteListRefetch,
  } = useGetSiteLists({
    authToken,
    leftPanelOpen: true,
  });
  const siteList =
    siteLists &&
    siteLists?.status === "ok" &&
    siteLists?.siteList?.length > 0
      ? siteLists?.siteList.map((site) => site.siteName)
      : [];

  const isRoleDisabled = (targetRole) => {
    const myLevel = roleHierarchy[userRole];
    const targetLevel = roleHierarchy[targetRole];
    console.log(
      `→ disabling? "${targetRole}" (lvl ${targetLevel}) >= "${role}" (lvl ${myLevel}) →`,
      targetLevel >= myLevel
    );
    return targetLevel > myLevel;
  };

  let roles = ["pooladmin", "admin", "readonly"];
  const [submitMsg, setSubmitMsg] = React.useState("");
  const [Msg, setMsg] = React.useState("");
  const [successModalOpen, setSuccessModalOpen] =
    React.useState(false);
  const [nameFilled, setNameFilled] = React.useState(false);
  const [emailFilled, setEmailFilled] =
    React.useState(false);
  const [roleFilled, setRoleFilled] = React.useState(false);
  const [domains, setDomains] = React.useState([]);
  const [errorPhone, setErrorPhone] = React.useState({
    error: false,
    helperText: "",
  });

  const handleCloseSuccessModal = () => {
    setSuccessModalOpen(false);
  };

  function isValidEmail(email) {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,10})+$/;
    return pattern.test(email);
  }

  const checkEmail = (value) => {
    const valid = isValidEmail(value);
    if (valid) {
      const valid1 = EmailValidator.validate(value);
      if (!valid1) {
        setError({
          error: true,
          helperText: "Invalid email",
        });
      } else {
        setError({ error: false, helperText: "" });
      }
      return valid1;
    } else {
      setError({
        error: true,
        helperText: "Invalid email",
      });
    }
    return valid;
  };

  const checkRole = (value) => {
    if (value == "true" || value == "false") {
      setErrorRole({ error: false, helperText: "" });
      return true;
    } else {
      setErrorRole({
        error: true,
        helperText:
          "Invalid role value (allowed true or false)",
      });
      return false;
    }
  };

  const handleInputChange = (event) => {
    const target = event.target;
    const value =
      target.type === "checkbox"
        ? target.checked
        : target.value;
    // console.log(value)
    checkEmail(value);
    setEmail(value);
    setEmailFilled(value.trim() !== "");
  };

  const handleInputChangeName = (event) => {
    const target = event.target;
    const value = target.value;
    setName(value);
    // Check if the input is not empty
    setNameFilled(value.trim() !== "");
  };

  const handleInputChangeRole = (event) => {
    const target = event.target;
    const value = target.value;
    const inputValue = event.target.value.toLowerCase();
    // checkRole(inputValue);
    setRole(inputValue);
    setRoleFilled(true);
  };

  const handleInputChangePhone = (event) => {
    const value = event.target.value;

    // Validate the phone number
    if (!validatePhoneNumber(value)) {
      setErrorPhone({
        error: true,
        helperText:
          "Invalid phone number. Must be 10 digits.",
      });
    } else {
      setErrorPhone({
        error: false,
        helperText: "",
      });
    }

    setPhone(value);
  };

  const handleInputChangeAddress = (event) => {
    const target = event.target;
    const value =
      target.type === "checkbox"
        ? target.checked
        : target.value;

    // console.log(value)
    setAddress(value);
  };

  const handleSiteConfigDeletion = (optionToDelete) => {
    const newValue = siteOptions.filter(
      (option) => option !== optionToDelete
    );
    setSiteOptions(newValue);
  };

  const handleInputChangePermissions = (
    event,
    newValue
  ) => {
    setSiteOptions(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setName("");
    setEmail("");
    setRole("");
    setPhone("");
    setAddress("");
    setSiteOptions([]);
    setError({
      error: false,
      helperText: "",
    });
    setErrorRole({
      error: false,
      helperText: "",
    });
    setNameFilled(false);
    setEmailFilled(false);
    setRoleFilled(false);
    setOpen(false);
  };

  React.useEffect(() => {
    if (org !== null) {
      const domainList = [];

      if (org.hasOwnProperty("domain") && org.domain) {
        domainList.push(org.domain);
      }

      if (
        org.hasOwnProperty("domains") &&
        Array.isArray(org.domains)
      ) {
        domainList.push(...org.domains);
      }

      // Ensure uniqueness
      const uniqueDomains = Array.from(new Set(domainList));

      setDomains(uniqueDomains);
    }
  }, [org]);

  const submitHandler = async (event) => {
    if (error.error) return;

    const fn = async () => {
      var localrole = role.toLowerCase();
      if (role.toLowerCase() === "readonly") {
        localrole = "user";
      }
      const token = await getAccessTokenSilently();
      let data = await api.PostInvite(token, {
        email: email,
        name: name,
        role: localrole,
        phone: phone,
        address: address,
        permissions: {
          sites: siteOptions,
        },
      });
      if (data.status === "ok") {
        setMsg(data.msg);
        setToastMessage(data.msg);
        setToastOpen(true);
        await membersDataRefetch();
        // setSubmitMsg("ok");
        // setSuccessModalOpen(true);
      } else {
        if (
          data.hasOwnProperty("errorCode") &&
          data.errorCode === 1009
        ) {
          setToastMessage(`Error: ${data.msg}`);
          setToastOpen(true);
        } else {
          setToastMessage(`Error: ${data.msg}`);
          setToastOpen(true);
        }
      }
      setState((prevState) => !prevState);
      setOpen(false);
    };
    fn();
  };

  const validatePhoneNumber = (phone) => {
    // Regular expression for validating phone numbers
    const phoneRegex = /^[0-9]{10}$/; // Matches a 10-digit number
    return phoneRegex.test(phone);
  };

  return (
    <div>
      <PrimaryButton colors={colors}
        variant="outlined"
        onClick={handleClickOpen}
        disabled={userRole === "user"}
      >
        {" "}
        Invite
      </PrimaryButton>
      <StyledDialog
        colors={colors}
        maxWidth="sm"
        sx={{ overflow: "hidden" }}
        open={open}
        onClose={handleClose}
      >
        <Box
          style={{
            overflowY: "scroll",
            scrollbarWidth: "thin",
            scrollbarbehavior: "smooth",
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            paddingTop={"1rem"}
            paddingBottom={"1rem"}
            gap={2}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              flexGrow={1}
            >
              <H6HeadlineSmall
                style={{ textAlign: "left" }}
              >
                Invite user
              </H6HeadlineSmall>
              <StyledIconButton onClick={handleClose} colors={colors}>
                <CloseIcon />
              </StyledIconButton>
            </Box>
            <BodyMedium style={{ textAlign: "left" }}>
              {" "}
              You’re adding a new team member to FluxVision.
              After the invitation is sent, they will
              receive an email to set up their account.
            </BodyMedium>
          </Box>

          <>
            <Box
              display={"flex"}
              flexDirection={"column"}
              flexShrink={0}
              gap={4}
            >
              <StyledTextField colors={colors}
                autoFocus
                name="name"
                label="Name"
                type="name"
                size={"medium"}
                value={name}
                fullWidth
                variant="outlined"
                onChange={handleInputChangeName}
                error={errorName.error}
                helperText={errorName.helperText}
              />
              <StyledTextField colors={colors}
                autoFocus
                name="address"
                size={"medium"}
                label="Address"
                type="address"
                value={address}
                fullWidth
                variant="outlined"
                onChange={handleInputChangeAddress}
              />
              <StyledFormControl colors={colors} fullWidth>
                <StyledInputLabel colors={colors}>Role</StyledInputLabel>
                <StyledSelect
                  value={role}
                  colors={colors}
                  label="Role"
                  fullWidth
                  onChange={handleInputChangeRole}
                  error={errorRole.error}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 250,
                        overflowY: "auto",
                        backgroundColor: colors.background.paper,
                        color: colors.text.primary,
                      },
                    },
                  }}
                >
                  {roles.map(
                    (role) =>
                      !isRoleDisabled(role) && (
                        <StyledMenuItem   value={role} colors={colors}>
                          {capitalize(role)}
                        </StyledMenuItem>
                      )
                  )}
                </StyledSelect>
              </StyledFormControl>
              <StyledTextField colors={colors}
                autoFocus
                name="phone"
                label="Phone number "
                size={"medium"}
                type="phone"
                value={phone}
                fullWidth
                variant="outlined"
                onChange={handleInputChangePhone}
                error={errorPhone.error}
                helperText={errorPhone.helperText}
              />
              <Stack direction={"column"} gap={4}>
                <StyledTextField colors={colors}
                  autoFocus
                  size={"medium"}
                  name="email"
                  label="Email address"
                  type="email"
                  value={email}
                  fullWidth
                  variant="outlined"
                  onChange={handleInputChange}
                  helperText={error.helperText}
                  error={error.error}
                />
                {Array.isArray(domains) &&
                  domains.length !== 0 && (
                    <>
                      <BodyMedium>
                        Allowed email domains:
                      </BodyMedium>
                      <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        gap={2}
                      >
                        {domains.map((domain, index) => (
                          <StyledLabel key={index} colors={colors}>
                            <BodySmall noWrap>
                              {domain}
                            </BodySmall>
                          </StyledLabel>
                        ))}
                      </Stack>
                    </>
                  )}
                {userRole === "superadmin" && (
                  <>
                    <Autocomplete
                      fullWidth
                      multiple
                      disableCloseOnSelect
                      onChange={
                        handleInputChangePermissions
                      }
                      ListboxProps={{
                        sx: {
                          fontSize: "1rem",
                          fontWeight: 400,
                          lineHeight: "1.5rem",
                          fontFamily: "Roboto",
                          backgroundColor: colors.background.paper,
                          "&.selected": {
                            backgroundColor:
                              colors.primary.light,
                          },
                          color: colors.text.primary,
                        },
                      }}
                      slotProps={{
                        popupIndicator: {
                          sx: { color: colors.text.muted , 
                          '&:hover': { color: colors.text.primary },
                        }
                        },
                        clearIndicator: {
                          sx: {
                            color: colors.text.muted,
                            '&:hover': { color: colors.text.primary },
                          },
                        },
                      }}
                      value={siteOptions}
                      clearIcon={null}
                      options={siteList}
                      renderInput={(params) => (
                        <StyledTextField colors={colors}
                          {...params}
                          label="Site Name"
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {(isSiteGroupDataFetching ||
                                  isSiteGroupDataLoading) && (
                                  <CircularProgress
                                    size={24}
                                    sx={{
                                      color: colors.primary.main,
                                    }}
                                  />
                                )}
                                {
                                  params.InputProps
                                    .endAdornment
                                }
                              </>
                            ),
                          }}
                        />
                      )}
                      renderTags={() => null}
                    />

                    {siteOptions.length > 0 && (
                      <Stack
                        direction="row"
                        flexWrap="wrap"
                        gap={2}
                      >
                        {siteOptions.map((site, index) => (
                          <PlaceHolderButton
                            key={index}
                            onClose={() =>
                              handleSiteConfigDeletion(site)
                            }
                            text={site}
                          />
                        ))}
                      </Stack>
                    )}
                  </>
                )}
              </Stack>
            </Box>
          </>
          <DialogActions>
            <PrimaryButton colors={colors}
              onClick={submitHandler}
              disabled={
                !nameFilled ||
                !emailFilled ||
                !roleFilled ||
                errorPhone.error
              }
            >
              Save
            </PrimaryButton>
          </DialogActions>
        </Box>
      </StyledDialog>
      <div>
        <SuccessModal
          isOpen={successModalOpen}
          onClose={handleCloseSuccessModal}
          Status={submitMsg}
          Msg={Msg}
        />
      </div>
    </div>
  );
}
